/* eslint-disable react/forbid-dom-props */
import type { FC } from 'react';
import { useState } from 'react';

import { Icon, IconName, Sizes, useAuthContext } from '@catalyze/ui';
import type { TExpectedDecisionMaker } from 'api/types/edm';
import { EdmStatus } from 'api/types/edm';

import { Card } from './components/Card';
import {
    Container,
    EDMSContainer,
    SectionTitle,
    StyledButton,
    HeaderContainer,
    EmptyState,
} from './styled';

const NEW_EDM_MOCK: TExpectedDecisionMaker = {
    edmId: 0,
    status: EdmStatus.NEW,
    age: 0,
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    phones: [
        {
            number: '',
            dnc: true,
        },
    ],
    emails: [
        {
            value: '',
        },
    ],
    addresses: [
        {
            address: '',
            city: '',
            zip: '',
            state: '',
        },
    ],
};

const MAX_EDMS_COUNT = 3; // max EDM count

interface IExpectedDecisionMakers {
    edmsData: TExpectedDecisionMaker[];
}

export const ExpectedDecisionMaker: FC<IExpectedDecisionMakers> = ({
    edmsData,
}) => {
    const { user } = useAuthContext();
    const [isNewCard, setNewCard] = useState<boolean>(false);

    if (!user) {
        return <div />;
    }

    return (
        <Container>
            <HeaderContainer>
                <SectionTitle>Expected Decision Makers</SectionTitle>
                <StyledButton
                    disabled={edmsData.length === MAX_EDMS_COUNT}
                    onClick={() => setNewCard(true)}
                    className="tooltip"
                >
                    <span
                        className="tooltiptext"
                        style={{
                            display:
                                edmsData.length !== MAX_EDMS_COUNT
                                    ? 'none'
                                    : '',
                        }}
                    >
                        You can only have up to 3 EDMs, to add another please
                        delete an existing one.
                    </span>
                    <Icon iconName={IconName.PLUS_CIRCLE} /> Add new
                </StyledButton>
            </HeaderContainer>
            <EDMSContainer>
                {!isNewCard && !edmsData.length && (
                    <EmptyState size={Sizes.XL}>
                        You have no expected decision makers.
                    </EmptyState>
                )}
                {isNewCard && (
                    <Card
                        isNew
                        data={NEW_EDM_MOCK}
                        closeNewCard={() => setNewCard(false)}
                    />
                )}
                {edmsData.map((edm: TExpectedDecisionMaker) => (
                    <Card key={edm.id} data={edm} showDnc={user?.showDnc} />
                ))}
            </EDMSContainer>
        </Container>
    );
};
